module.exports = __webpack_public_path__ + "img/swiper-left-btn.37629ed7.svg";